module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-69e318bc.png";